import config from '../config';
import CtaBand from '../components/CtaBand';
import Footer from '../components/Footer';

// ── SERVICES CONTENT ─ edit here ──────────────────────────────

const SERVICES = [
  {
    num: '01', title: 'INSTALLATION',
    desc: 'Komplett montering av kyl- och frysanläggningar, klimatsystem och all storköksutrustning – från planering och rörläggning till driftsättning och sluttest.',
    icon: (
      <svg className="bci" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <polyline points="13 2 13 9 20 9"/>
        <path d="M20 14v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"/>
      </svg>
    ),
    items: [
      'Kylaggregat, kyldiskar och kylrum',
      'Frysskåp, frysboxar och frysrum',
      'Split- och multisplit AC-system',
      'Storköksutrustning (ugnar, diskmaskiner m.m.)',
      'Rörläggning och elektrisk anslutning',
      'Idrifttagning, sluttest och dokumentation',
    ],
  },
  {
    num: '02', title: 'SERVICE',
    desc: 'Regelbunden service och förebyggande underhåll som förlänger livslängden och minskar risken för kostsamma haverier. Fasta serviceavtal anpassade efter din verksamhet.',
    icon: (
      <svg className="bci" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
    items: [
      'Serviceavtal 1–4 gånger per år',
      'Kondensor- och förångartvätt',
      'Kontroll av köldmedienivåer (F-gas cert.)',
      'Filter- och lamellrengöring (AC)',
      'Tätnings- och dörrtätningskontroll',
      'Temperaturkalibrering och loggning',
      'Prioriterad responstid för avtalskunder',
    ],
  },
  {
    num: '03', title: 'FELSÖKNING',
    desc: 'Snabb och träffsäker diagnostik när något går fel. Vi hittar grundorsaken – inte bara symtomet – och åtgärdar det direkt. Jourlinje dygnet runt.',
    icon: (
      <svg className="bci" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
      </svg>
    ),
    items: [
      'Jourlinje 24/7 – mål: utryckning inom 4 h',
      'Digital felkodläsning och diagnostik',
      'Läckagesökning köldmedier',
      'Elektrisk felsökning och styrsystem',
      'Reservdelar på fordonet – åtgärd direkt',
      'Tillfälliga kylaggregat vid längre jobb',
      'Skaderapport för försäkringsärenden',
    ],
  },
  {
    num: '04', title: 'SERVICEAVTAL',
    desc: 'Förebyggande underhåll med fasta avtal – skräddarsydda efter din verksamhet. Vi håller koll på dina anläggningar så att du slipper oväntade stillestånd och kostsamma akutjobb.',
    icon: (
      <svg className="bci" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="9" y="2" width="6" height="4" rx="1"/>
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    items: [
      'Inspektioner 1–4 gånger per år',
      'Prioriterad responstid vid akutärenden',
      'Serviceprotokoll och full dokumentation',
      'Rabatt på reservdelar och arbete',
      'Anpassade avtal för alla storlekar',
      'Temperaturloggning och kontroll',
      'Påminnelse inför varje service',
    ],
  },
];

const EQUIPMENT_PRIMARY = [
  {
    tag: '★ Primär', title: 'KYLAGGREGAT & KYLDISKAR',
    desc: 'Industrikylare, kyldiskar, kyldepåer och butikskylare. Installation, service och felsökning på alla modeller.',
    items: ['Gram, True, Foster, Liebherr m.fl.', 'Köldmediebyte – F-gas certifierat', 'Kondensor- och förångartvätt'],
    icon: (
      <svg className="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="4" y="2" width="16" height="20" rx="2"/>
        <line x1="4" y1="10" x2="20" y2="10"/>
        <line x1="9" y1="6" x2="9" y2="8"/><line x1="9" y1="14" x2="9" y2="18"/>
      </svg>
    ),
  },
  {
    tag: '★ Primär', title: 'FRYSSKÅP & FRYSRUM',
    desc: 'Stående och liggande frysskåp, djupfrysar och industriella frysrum. Installation, service och felsökning.',
    items: ['Tätningskontroll och avfrostning', 'Temperaturövervakning', 'Alla storlekar och fabrikat'],
    icon: (
      <svg className="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/>
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/><line x1="19.07" y1="4.93" x2="4.93" y2="19.07"/>
        <circle cx="12" cy="12" r="2.5"/>
      </svg>
    ),
  },
  {
    tag: '★ Primär', title: 'LUFTKONDITIONERING',
    desc: 'Split- och multisplitsystem för restauranger och storkök. Installation, service och felsökning.',
    items: ['Daikin, Panasonic, Carrier m.fl.', 'Säsongsservice vår och höst', 'Filter- och lamellrengöring'],
    icon: (
      <svg className="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/>
      </svg>
    ),
  },
];

const EQUIPMENT_SECONDARY = [
  {
    tag: 'Tillägg', title: 'DISKMASKINER',
    desc: 'Service och felsökning av bandmaskiner, huvmaskiner och underbänksdiskmaskiner för alla storkök.',
    items: ['Rengöring filter och munstycken', 'Kontroll vattentryck och temperatur', 'Byte av förslitningsdelar'],
    icon: (
      <svg className="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <line x1="3" y1="9" x2="21" y2="9"/><circle cx="8" cy="15" r="2"/>
        <line x1="13" y1="13" x2="19" y2="13"/><line x1="13" y1="17" x2="19" y2="17"/>
      </svg>
    ),
  },
  {
    tag: 'Tillägg', title: 'UGNAR, STEKBORD & KOKKÄRL',
    desc: 'Service och felsökning av konvektionsugnar, kombiskåp, stekbord, fritering och tillagningskärl.',
    items: ['Termostat- och elementbyten', 'Säkerhetskontroll och funktionstest', 'El- och gasanslutna modeller'],
    icon: (
      <svg className="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="4" width="20" height="18" rx="2"/>
        <rect x="6" y="10" width="12" height="8" rx="1"/>
        <circle cx="8" cy="7" r="1"/><circle cx="12" cy="7" r="1"/><circle cx="16" cy="7" r="1"/>
      </svg>
    ),
  },
];

// ══════════════════════════════════════════════════════════════
export default function Services({ navigate }) {
  return (
    <>
      {/* ── HERO ── */}
      <div className="ph2">
        <div className="sl c">Tjänster</div>
        <div className="st">VAD VI GÖR</div>
        <p>
          Vi erbjuder fyra kärnuppdrag –{' '}
          <strong>installation</strong>, <strong>service</strong>,{' '}
          <strong>felsökning</strong> och <strong>serviceavtal</strong> –
          på kyl, frys, värme och storköksutrustning i hela Göteborg och Västra Götaland.
        </p>
      </div>

      {/* ── SERVICE CARDS ── */}
      <div className="big3">
        {SERVICES.map(({ num, title, desc, icon, items }) => (
          <div className="bc" key={num}>
            <div className="bcn">{num}</div>
            {icon}
            <div className="bcl" />
            <div className="bct">{title}</div>
            <div className="bcd">{desc}</div>
            <ul className="svl">
              {items.map(item => <li key={item}>{item}</li>)}
            </ul>
          </div>
        ))}
      </div>

      {/* ── SERVICEAVTAL HIGHLIGHT ── */}
      <div style={{ margin:'0 5vw 60px', padding:'40px 48px', background:'rgba(0,153,198,.06)', border:'1px solid rgba(0,153,198,.2)', borderLeft:'4px solid var(--accent)', borderRadius:4, display:'flex', alignItems:'center', gap:40, flexWrap:'wrap' }}>
        <div style={{ flex:1, minWidth:260 }}>
          <div className="sl" style={{ marginBottom:8 }}>Trygghet hela året</div>
          <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.6rem', color:'var(--navy)', marginBottom:10, letterSpacing:.5 }}>TECKNA ETT SERVICEAVTAL</div>
          <p style={{ fontSize:'.9rem', color:'var(--muted)', lineHeight:1.7, maxWidth:520 }}>
            Med ett serviceavtal hos BeCool slipper du tänka på underhållet. Vi bokar in regelbundna besök,
            dokumenterar varje inspektion och ser till att din utrustning alltid är i toppskick –
            oavsett om det gäller kyla, frys eller värmesystem.
          </p>
        </div>
        <button className="bp" onClick={() => navigate('contact')} style={{ flexShrink:0 }}>Begär avtal</button>
      </div>

      {/* ── EQUIPMENT ── */}
      <div className="esec">
        <div className="sl">Utrustning vi täcker</div>
        <div className="st">ALL UTRUSTNING – ALLA MÄRKEN</div>
        <div className="ss">Vi utför installation, service och felsökning på alla fabrikat. Kyla och värme är primärt – övrig storköksutrustning täcks som tilläggstjänst.</div>

        <div className="egd t3">
          {EQUIPMENT_PRIMARY.map(({ tag, title, desc, icon, items }) => (
            <div className="ec w" key={title}>
              <span className="tag-p">{tag}</span>
              {icon}
              <div className="et">{title}</div>
              <div className="ed">{desc}</div>
              <ul className="svl">{items.map(i => <li key={i}>{i}</li>)}</ul>
            </div>
          ))}
        </div>

        <div className="ediv">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color:'var(--muted)', flexShrink:0 }}>
            <path d="M3 6h18M3 10h18M5 6V4M19 6V4"/>
          </svg>
          <span>Övrig storköksutrustning – tilläggstjänster</span>
        </div>

        <div className="egd b2">
          {EQUIPMENT_SECONDARY.map(({ tag, title, desc, icon, items }) => (
            <div className="ec g" key={title}>
              <span className="tag-s">{tag}</span>
              {icon}
              <div className="et">{title}</div>
              <div className="ed">{desc}</div>
              <ul className="svl">{items.map(i => <li key={i}>{i}</li>)}</ul>
            </div>
          ))}
        </div>
      </div>

      {/* ── BRANDS ── */}
      <div className="bsec">
        <div className="sl c">Märken vi servar</div>
        <div className="st" style={{ textAlign:'center' }}>KYLA, VÄRME &amp; FRYS – ALLA FABRIKAT</div>
        <div className="bgd">
          {config.brands.map(({ name, type }) => (
            <div className="bch" key={name}>
              <div className="bn">{name}</div>
              <div className="bt">{type}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA ── */}
      <CtaBand
        label="Offert"
        heading="REDO ATT KOMMA IGÅNG?"
        text="Kontakta oss för ett kostnadsfritt prisförslag. Vi svarar inom 24 timmar – jouret är öppet dygnet runt för akuta ärenden."
        btnLabel="Kontakta oss"
        onAction={() => navigate('contact')}
      />

      <Footer navigate={navigate} />
    </>
  );
}
